export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBsrB4WEEOKMhV85a0UbNnPEsVEouk_unY',
    authDomain: 'aladin-shop-5b628.firebaseapp.com',
    databaseURL: 'https://aladin-shop-5b628.firebaseio.com',
    projectId: 'aladin-shop-5b628',
    storageBucket: 'aladin-shop-5b628.appspot.com',
    messagingSenderId: '488682974016'
  }
};



// WEBPACK FOOTER //
// C:/dev1/Aladin-SHOP/src/environments/environment.ts